import { Component, NgZone, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading: boolean = false;
  error: string = null;
  loginSubscriber: Subscription;

  constructor(private authService: AuthService, private router: Router, private ngZone: NgZone) { }

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      'email': new FormControl(null, [Validators.required, Validators.email]),
      'password': new FormControl(null, [Validators.required, Validators.minLength(6)])
    });
  }

  onSubmit(): void {
    if (this.loginForm.invalid) { return; }
    const email = this.loginForm.value.email;
    const password = this.loginForm.value.password;

    this.isLoading = true;
    this.error = null;
    this.ngZone.run(_ => {
      this.loginSubscriber = this.authService.login(email, password).subscribe(_ => {
        this.router.navigate(['/admin/practitioners']);
        this.isLoading = false;
        this.error = null;
      }, errorResponse => {
        this.isLoading = false;
        this.error = errorResponse;
      });
    });
  }

  ngOnDestroy(): void {
    if (!this.loginSubscriber) { return; }
    this.loginSubscriber.unsubscribe();
  }
}
